import { IInfo } from '@r1-frontend/api-domru/api-loyalty/v1/program/info';

import { IAction } from '~/src/store';
import { LOYALTY_AVAILABILITY, LOYALTY_INFO } from '~/src/store/actionTypes/loyalty';
import { IAvailiabilityData } from '~/src/store/reducers/loyalty';

export const setLoyaltyAvailability = (data: IAvailiabilityData): IAction<typeof LOYALTY_AVAILABILITY, IAvailiabilityData> => {
    return {
        type: LOYALTY_AVAILABILITY,
        payload: data,
    };
};

export const setLoyaltyInfo = (info: IInfo): IAction<typeof LOYALTY_INFO, IInfo> => {
    return {
        type: LOYALTY_INFO,
        payload: info,
    };
};
